import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box } from '@mui/material';
import lightTheme from '@/src/styles/themes/lightTheme';
import React, { FocusEventHandler } from 'react';
import { ILooseObject } from '@/src/types/common.interface';

interface IRichEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  toolbarOptions?: Array<Array<ILooseObject | string>>;
  formats?: string[];
  modules?: object;
  onBlur?: FocusEventHandler<any>;
}

const defaultToolbar = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link', 'image'],
  ['clean']
];

const defaultFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'code',
  'list',
  'bullet',
  'link',
  'image',
  'code-block',
  'clean'
];

const RichEditor: React.FC<IRichEditorProps> = (props: IRichEditorProps) => {
  const { onChange, value, formats, placeholder, toolbarOptions, onBlur } = props;

  // modules expects an object
  // const updatedModules =  [...defaultToolbar,...toolbarOptions??[]];
  const updatedFormats = [...defaultFormats, ...(formats ?? [])];

  const updatedModules = {
    toolbar: toolbarOptions ?? defaultToolbar
    // other properties can be set here
  };

  const handleChange = (content: string) => {
    onChange(content ?? '');
  };

  // ReactQuill's onBlur event signature: (previousRange, source, editor)
  const handleBlur = () => {
    if (onBlur) {
      // Create a synthetic event to match FocusEventHandler signature
      const syntheticEvent = { target: { value }, type: 'blur' } as any;
      onBlur(syntheticEvent);
    }
  };

  return (
    <Box
      sx={{
        '& .ql-snow .ql-editor pre.ql-syntax': {
          background: lightTheme.palette.background.default,
          color: lightTheme.palette.text.primary,
          fontFamily: "'Fira Mono', 'Consolas', 'Menlo', 'Monaco', 'monospace'",
          fontSize: '0.95em',
          borderRadius: '4px',
          padding: '0.5em',
          overflowX: 'auto'
        }
      }}
    >
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        modules={updatedModules}
        formats={updatedFormats}
        onBlur={handleBlur}
      />
    </Box>
  );
};

export default RichEditor;
